import { render, staticRenderFns } from "./ChooseType.vue?vue&type=template&id=76509491&"
import script from "./ChooseType.vue?vue&type=script&lang=js&"
export * from "./ChooseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports